import * as React from "react"
import { connect } from "react-redux"
import bem from "../../../bem"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { ItemBlockPart, Selector } from "@tenforce/toolbox-selector-react"
import { GlobalState } from "../../../store"
import { DispatchProps, mapDispatchToProps } from "../actions"
import { Symbols } from "@tenforce/toolbox-fontmap"
import ReportAction from "./ReportAction"

import "./Report.scss"
import { Labels } from "../../../util/Translations"

type StateProps = Contracts.Contracts

type Props = StateProps & DispatchProps

const b = bem.with("NewUI__report")

export class Report extends React.PureComponent<Props> {
    render(): JSX.Element {
        const { report } = this.props
        const data = report?.data
        const compliant = data?.compliant
        const repaired = data?.repaired
        const hasActions = (data?.actions?.length ?? 0) > 0
        const {
            Validation,
            ContractViolatedDescription,
            Violated,
            Compliant,
            ContractCompliantDescription,
            PleaseReviewChanges,
            Repair,
        } = Labels
        return (
            <div className={b()}>
                <div className="tw-flex-row-center">
                    <div className="tw-flex-grow tw-py-3 tw-px-4">
                        <h3>
                            {data?.source?.name}&nbsp;{Validation}
                        </h3>
                    </div>
                    <div className="tw-flex-row-center tw-pr-2">
                        <Selector isReadOnly={true}>
                            {compliant ? (
                                <ItemBlockPart
                                    partProps={{ color: "rgb(21,234,52)" }}
                                    isSelected={true}
                                >
                                    <span className="label">{Compliant}</span>
                                </ItemBlockPart>
                            ) : (
                                <ItemBlockPart
                                    partProps={{ color: "rgb(229,0,21)" }}
                                    isSelected={true}
                                >
                                    <span className="label">{Violated}</span>
                                </ItemBlockPart>
                            )}
                        </Selector>
                        {hasActions && !repaired && (
                            <Action
                                actionType={ActionType.icon}
                                onClick={this.repair}
                            >
                                {Symbols.Wrench}&nbsp;{Repair}
                            </Action>
                        )}
                    </div>
                </div>
                <div className="separator-line is-dimmed"></div>
                <div className="tw-pt-2 tw-pl-4">
                    {compliant && !repaired && (
                        <span>{ContractCompliantDescription}</span>
                    )}
                    {compliant && repaired && (
                        <span>{PleaseReviewChanges}</span>
                    )}
                    {!compliant && <span>{ContractViolatedDescription}</span>}
                </div>
                <div className={`${b("actions")} tw-pl-1`}>
                    <ul>
                        {hasActions &&
                            data?.actions.map((contract, idx) => (
                                <ReportAction
                                    key={`action-${idx}`}
                                    action={contract}
                                />
                            ))}
                    </ul>
                </div>
            </div>
        )
    }

    repair = (): void => {
        const { report, repairContract } = this.props
        const contractId = report?.data?.source?.id
        if (contractId) {
            repairContract(contractId)
        }
    }
}

const mapStateToProps = (state: GlobalState): StateProps => state.contracts

export default connect(mapStateToProps, mapDispatchToProps)(Report)
